import { Box, BoxProps } from '@mui/material'

export const AcBox = ({ children, ...props }: BoxProps) => {
  return <Box {...props}>{children}</Box>
}
